import { Card } from "@/components/Card";
import { SectionHeader } from "@/components/SectionHeader";
import { SettingsRow } from "@/components/SettingsRow";

const TEAM = [
  { name: "Matthias Jurisch", role: "Konzeption, Backend & Domain-Logik" },
  { name: "PZRM-Team", role: "Anforderungen & fachlicher Test" },
];

export function AboutSection() {
  return (
    <Card>
      <SectionHeader title="Über das System" />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: "8px 0 16px",
          borderBottom: "1px solid var(--border)",
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            background: "var(--brand-100)",
            borderRadius: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src="/app/LogoPZRM.png" alt="" style={{ width: 48, height: 48, objectFit: "contain" }} />
        </div>
        <div>
          <div className="display" style={{ fontSize: 18, color: "var(--brand-900)" }}>
            Buchungssystem Raumünzach
          </div>
          <div style={{ fontSize: 12, color: "var(--fg-muted)" }}>
            Pfadfinderzentrum Raumünzach
          </div>
        </div>
      </div>

      <div style={{ padding: "12px 0", borderBottom: "1px solid var(--border)" }}>
        <div
          style={{
            fontSize: 11,
            textTransform: "uppercase",
            letterSpacing: ".09em",
            color: "var(--fg-subtle)",
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          Team
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {TEAM.map((p) => (
            <div
              key={p.name}
              style={{ display: "flex", alignItems: "baseline", gap: 12, fontSize: 13 }}
            >
              <span style={{ fontWeight: 600, minWidth: 200 }}>{p.name}</span>
              <span style={{ color: "var(--fg-muted)", fontSize: 12 }}>{p.role}</span>
            </div>
          ))}
        </div>
      </div>

      <SettingsRow label="Support">
        <a href="mailto:support@pzrm.de" style={{ color: "var(--brand-700)" }}>
          vorstand@pzrm.de
        </a>
      </SettingsRow>
      <SettingsRow label="Dokumentation">
        <a href="/app/settings?section=handbuch" style={{ color: "var(--brand-700)" }}>
          Handbuch öffnen
        </a>
      </SettingsRow>
      <SettingsRow label="Quellcode" hint="Issues & Mitwirken über Git-Repository">
        <span style={{ color: "var(--fg-muted)", fontSize: 12 }}>matthiasjurisch/pzrm-buchungssystem</span>
      </SettingsRow>
    </Card>
  );
}
